<a
  class="onact96-a"
  [href]="'/' + appService.languageCode"
  (click)="$event.preventDefault(); click()"
  *ngIf="clickable"
></a>

@if (isOnline) {
  <img class="logo-img" [src]="logoUrl" [style.width]="width" [style.height]="height" />
} @else {
  <div class="logo" [style.width]="width" [style.height]="height"></div>
}
